import { Button } from "@lya-protect/lya-protect-form-library/dist/UI";
import styles from "./ConfirmDialog.module.scss";
import { Dialog } from "./Dialog";

export type ConfirmDialogProps = {
  title?: string;
  /**
   * Rendered inside a `<p>` — inline content only (`<strong>`, `<br/>`, plain
   * text…). A block-level element (`<div>`, another `<p>`, a list…) here would
   * produce invalid HTML, since it would be nested inside that `<p>`.
   */
  message?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onClose?: (value: boolean) => void;
  dialogRef: React.MutableRefObject<HTMLDialogElement | null>;
};
export function ConfirmDialog({
  title,
  message,
  confirmText,
  cancelText,
  onClose,
  dialogRef,
}: ConfirmDialogProps) {
  return (
    <Dialog dialogRef={dialogRef}>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.message}>{message}</p>
      <div className={styles.actions}>
        {cancelText && (
          <Button
            variant="text"
            onClick={(e) => {
              e.stopPropagation();
              onClose?.(false);
            }}
          >
            {cancelText}
          </Button>
        )}
        <Button
          variant="filled"
          onClick={(e) => {
            e.stopPropagation();
            onClose?.(true);
          }}
        >
          {confirmText}
        </Button>
      </div>
    </Dialog>
  );
}
